import { apiGet } from 'api';
import { GetPermissionsResponse } from '../../types';

export const getPermissions = (): Promise<GetPermissionsResponse> =>
  apiGet<GetPermissionsResponse>('permissions');
